module.exports = __webpack_public_path__ + "img/wushui.16444d33.png";